export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-regular-c04c7bf480ce24c2031538291da937b7.woff";